import { instance } from "hooks/useRequest/helper";
import * as ApiUrl from "api/routes";



export const getServiceType = async () => {
    const res = await instance.get(ApiUrl.SERVICE_TYPES_URL);
    return await res.data;
};